import { StateCreator } from "zustand";

import type MapEntityBase from "../services/map-management/map-entities/map-entity-base";
import { LegacySlice } from "./legacy-slice";

export interface CurrentSlice {
    selectedMapEntity: MapEntityBase | null;
    setSelectedMapEntity: (entity: MapEntityBase | null) => void;
    isRepositioningDevice: boolean;
    setIsRepositioningDevice: (isRepositioning: boolean) => void;
}

export const createCurrentSlice: StateCreator<CurrentSlice & LegacySlice, [], [], CurrentSlice> = (set, get) => ({
    selectedMapEntity: null,
    setSelectedMapEntity: (entity: MapEntityBase | null) => {
        set({ selectedMapEntity: entity });

        // Pass along the entity to the legacy slice
        get().setLegacySelected(entity);
    },
    isRepositioningDevice: false,
    setIsRepositioningDevice: (isRepositioning: boolean) => set({ isRepositioningDevice: isRepositioning }),
});
